import {
  Component,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  trigger,
  transition,
  style,
  animate,
  group,
} from '@angular/animations';
import { AuthService } from '@core/services/auth';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule, RouterModule],
  animations: [
    // Backdrop fades
    trigger('backdrop', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('180ms ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('150ms ease-in', style({ opacity: 0 }))]),
    ]),
    // Panel slides from right -> left
    trigger('panel', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate(
          '220ms cubic-bezier(.22,1,.36,1)',
          style({ transform: 'translateX(0%)' })
        ),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
  ],
  templateUrl: './sidebar-component.html',
  styleUrls: ['./sidebar-component.scss'],
})
export class SidebarComponent {
  /** controls visibility from parent */
  authService = inject(AuthService);
  router = inject(Router);
  @Input() open = true;
  @Input() isMobile = false;
  /** Desktop only: icon rail instead of full hide */
  @Input() collapsed = false;
  /** fire when user closes (backdrop, X, etc.) */
  @Output() closed = new EventEmitter<void>();
  /** Parent owns language modal (avoids fixed overlay clipped by sidebar). */
  @Output() openLanguage = new EventEmitter<void>();
  screenWidth = signal(window.innerWidth);

  close() {
    // Mobile: always close drawer after nav / ESC.
    // Desktop: keep sidebar open on route clicks; ESC still collapses via parent toggle.
    if (this.isMobile) {
      this.closed.emit();
    }
  }

  onResize() {
    this.screenWidth.set(window.innerWidth);
  }

  @HostListener('document:keydown.escape')
  onEsc() {
    if (!this.open) return;
    // Mobile: close drawer. Desktop: collapse to icon rail (when expanded).
    if (this.isMobile || !this.collapsed) {
      this.closed.emit();
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.onResize();
  }

  // stop clicks inside the panel from closing
  stop(e: Event) {
    e.stopPropagation();
  }

  handleLogout() {
    if (this.authService.logOutReqData.state().loading) {
      return;
    }
    this.close();
    this.authService._logout();
  }
  openLanModal() {
    this.openLanguage.emit();
  }
}
